// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uploader{float:left;width:100%;padding:15px 50px}.uploader .input-file{font-weight:600}.uploader__button{display:inline-block;border-radius:3px;padding:8px 12px;background:#f5001d;font-size:12px;color:#fff;font-weight:600;cursor:pointer;clear:both}.uploader__disclaimer{float:left;width:100%;font-size:12px}", ""]);
// Exports
module.exports = exports;
